/**
 * A lightweight in-memory cache for layout thumbnails.
 * Keys: layoutId (string | number)
 * Values: { url: string, expiry: number }
 */

const cache = new Map();

// Default TTL for cached URLs (30 minutes)
const DEFAULT_TTL_MS = 1000 * 60 * 30;

export const layoutThumbnailCache = {
  /**
   * Retrieves a thumbnail URL if not expired.
   * Returns null if expired or missing.
   */
  get(id) {
    const record = cache.get(id);
    if (!record) return null;

    const now = Date.now();
    if (record.expiry <= now) {
      cache.delete(id);
      return null;
    }
    return record.url;
  },

  /**
   * Saves a thumbnail URL with an expiry timestamp.
   */
  set(id, url, ttlMs = DEFAULT_TTL_MS) {
    cache.set(id, {
      url,
      expiry: Date.now() + ttlMs,
    });
  },

  /**
   * Removes a specific layout thumbnail from the cache.
   */
  remove(id) {
    cache.delete(id);
  },

  /**
   * Clears the entire cache (useful in debugging or logout events).
   */
  clear() {
    cache.clear();
  },
};

export default layoutThumbnailCache;
